import React from 'react';
import styled from '@emotion/native';
import BookingSummary from '@/components/bookConsultation/BookingSummary/BookingSummary';

interface Props {
  priceTierName: string;
  hourlyRate: number;
  onDismissModal?: () => void;
  discountCode?: string | null;
  discountPercentage?: number | null;
  onDiscountCodeChange?: (
    codeText: string | null,
    discountPercentage?: number | null,
  ) => void;
}

const ClientInstantCallReview = ({
  priceTierName,
  hourlyRate,
  onDismissModal,
  discountCode,
  discountPercentage,
  onDiscountCodeChange,
}: Props) => {
  return (
    <Container>
      <BookingSummary
        showHeader
        hideStylist
        priceTierName={priceTierName}
        hourlyRate={hourlyRate}
        isInstant
        onDismissModal={onDismissModal}
        initialDiscountCode={discountCode}
        initialDiscountPercentage={discountPercentage}
        onDiscountCodeChange={onDiscountCodeChange}
      />
    </Container>
  );
};

export default ClientInstantCallReview;

const Container = styled.View({
  width: '100%',
  paddingBottom: 56,
});
